export const AgsDataPackagesCodes = {
  AGS_CA_BASE: 'ags-ca-base',
  AGS_CA_PREMIUM: 'ags-ca-premium',
  AGS_CA_HEALTHCARE: 'ags-ca-healthcare',
  AGS_MX_BASE: 'ags-mx-base',
  AGS_MX_HEALTHCARE: 'ags-mx-healthcare',
  AGS_US_BASE: 'ags-us-base',
  AGS_US_PREMIUM: 'ags-us-premium',
  AGS_US_HEALTHCARE: 'ags-us-healthcare',
} as const;

export const SubscriptionAddonCodes = {
  ...AgsDataPackagesCodes,
} as const;

// | string below here because we don't guarantee BE doesn't have an addon FE doesn't know about
// but it shouldn't be relevant for type safety in the FE since we only do addon-specific logic for known addons
export type SubscriptionAddonCode = typeof SubscriptionAddonCodes[keyof typeof SubscriptionAddonCodes] | string;
